export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

export const categories: Category[] = [
  { id: "all", name: "全部", slug: "all", icon: "ri-movie-2-line" },
  { id: "movie", name: "电影", slug: "movie", icon: "ri-film-line" },
  { id: "tv", name: "电视剧", slug: "tv", icon: "ri-tv-line" },
  { id: "anime", name: "动漫", slug: "anime", icon: "ri-emotion-line" },
  { id: "variety", name: "综艺", slug: "variety", icon: "ri-live-line" },
  { id: "documentary", name: "纪录片", slug: "documentary", icon: "ri-earth-line" },
  { id: "kids", name: "少儿", slug: "kids", icon: "ri-heart-line" },
];

export const categoryNameMap: Record<string, string> = {
  all: "全部影视",
  movie: "电影大全",
  tv: "电视剧全集",
  anime: "动漫",
  variety: "综艺",
  documentary: "纪录片",
  kids: "少儿",
};

export const categoryTitleMap: Record<string, string> = {
  all: "全部影视资源 - 八戒影院",
  movie: "电影大全 - 高清电影在线观看 - 八戒影院",
  tv: "电视剧全集 - 热门电视剧免费在线观看 - 八戒影院",
  anime: "动漫 - 热门动漫在线观看 - 八戒影院",
  variety: "综艺 - 热门综艺节目在线观看 - 八戒影院",
  documentary: "纪录片 - 高清纪录片在线观看 - 八戒影院",
  kids: "少儿 - 少儿动画在线观看 - 八戒影院",
};

export const categoryDescMap: Record<string, string> = {
  all: "八戒影院汇聚海量最新影视资源，涵盖电影、电视剧、动漫、综艺、纪录片、少儿等全品类，高清在线流畅播放，热播剧新片上线抢先看不缓冲。",
  movie: "八戒影院电影大全，收录最新院线大片、经典老片、高分佳作，高清在线流畅播放。动作片、喜剧片、爱情片、科幻片等全类型覆盖，新片上线抢先看。",
  tv: "八戒影院电视剧全集，国产剧、韩剧、美剧、日剧、泰剧一网打尽。热播剧每日同步更新，全集高清在线免费观看，流畅不卡顿。",
  anime: "八戒影带动漫频道，日漫、国漫、欧美动漫一站式畅享。热门连载同步更新，经典番剧全收录，高清在线流畅播放。",
  variety: "八戒影院综艺频道，热门综艺节目每日更新。搞笑综艺、音乐选秀、真人秀、脱口秀等全类型综艺在线观看，精彩不缓冲。",
  documentary: "八戒影院纪录片频道，BBC、Discovery、CCTV等顶级纪录片高清在线观看。自然、历史、科技、人文等全主题覆盖。",
  kids: "八戒影院少儿频道，精选优质儿童动画和教育内容。小猪佩奇、汪汪队、宝宝巴士等热门IP全收录，安全健康的儿童观影平台。",
};